<template>
  <div class="havinLogo__container">
    <router-link v-if="homeData" to="/" class=" d-inline-block">
      <img
        loading="lazy"
        src="@/assets/images/logo.png"
        class="w-100 h-100"
        alt="sj"
      />
    </router-link>
  </div>
</template>
<script>
export default {
  computed: {
    homeData() {
      return this.$store.getters["front/getHomeData"];
    },
  },
};
</script>
<style scoped>
.havinLogo__container {
  width: 150px;
}
</style>
